import React, { useEffect } from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import axios from "axios";

import {
    StyledClose,
    StyledContent,
    StyledOverlay,
    StyledTrigger,
    Header,
    SectionBox,
    Content,
    LeftSide,
    ResponseList,
    RightSide,
    TitleHeader,
    TitleContent,
    AiFillCloseCircleIcon,
    FaUsersCogIcon,
    AddIcon,
    AdminIcon,
    AiFillDeleteIcon
} from './styles';

import { useState } from 'react';

import toast from 'react-hot-toast';

import { IClientProps } from '../../../interfaces';

import { apiBaseUrl } from '../../../api/base';

interface BitrixResp {
    codUser: string;
    nomeUser: string;
    lastName: string;
}

interface ClientResp {
    codBitrix: string;
    nome: string;
    codUser: string;
}

interface IManageClientData {
    id: string;
    client: IClientProps
}

const ManageClient: React.FC<IManageClientData> = ({ id, client }: IManageClientData) => {

    const [rerenderAux, setRerenderAux] = useState<boolean>(false);
    const [textSearch, setTextSearch] = useState<String>('');
    const [responseSearchBitrix, setresponseSearchBitrix] = useState<BitrixResp[]>(new Array());
    const [responseBitrixUsers, setResponseBitrixUsers] = useState<ClientResp[]>(new Array());

    useEffect(() => {
        const urlUsers = `${apiBaseUrl}/users/client/${id}`;

        axios.get(urlUsers).then(response => {
            const r = response.data.map((item: any): ClientResp => {
                return {
                    codBitrix: item.codBitrix,
                    nome: item.nome,
                    codUser: item.id
                }
            })
            setResponseBitrixUsers(r);
        })
    }, [rerenderAux]);

    useEffect(() => {
        const url = client.webhook + 'user.search'
        if (textSearch.length > 3) {
            axios.post(url, {
                "filter": {
                    "NAME": textSearch
                }
            }).then(response => {
                const r = response.data.result.map((item: any): BitrixResp => {
                    return {
                        codUser: item.ID,
                        nomeUser: item.NAME,
                        lastName: (!item.LAST_NAME) ? '' : item.LAST_NAME
                    }
                })
                setresponseSearchBitrix(r);
            })
        }

    }, [textSearch]);

    async function handleAddAdminButon(userToAdd: BitrixResp) {
        await axios.post(apiBaseUrl + '/users', {
            "nome": userToAdd.nomeUser,
            "codBitrix": userToAdd.codUser,
            "permissoes": ["DASH_CHAMADOS", "ADMIN"],
            "client": {
                "id": id
            }
        }).then(response => {
            toast.success(`Usuário ${userToAdd.nomeUser} adicionado com sucesso!`)
            setRerenderAux(!rerenderAux);
        }).catch(e => {
            toast.error(`Não foi possível adicinonar o usuário ${userToAdd.nomeUser}.`)
        })

    }

    async function handleAddButon(userToAdd: BitrixResp) {
        await axios.post(apiBaseUrl + '/users', {
            "nome": userToAdd.nomeUser,
            "codBitrix": userToAdd.codUser,
            "permissoes": ["DASH_CHAMADOS"],
            "client": {
                "id": id
            }
        }).then(response => {
            toast.success(`Usuário ${userToAdd.nomeUser} adicionado com sucesso!`);
            setRerenderAux(!rerenderAux);
        }).catch(e => {
            toast.error(`Não foi possível adicinonar o usuário ${userToAdd.nomeUser}.`)
        })
    }

    async function handleDeleteButon(userToDelete: ClientResp) {
        if (window.confirm('Deletar o item?')) {
            await axios.delete(`${apiBaseUrl}/users/${userToDelete.codUser}`).then(response => {
                confirm('Usuário ' + userToDelete.nome + ' deletado com sucesso')
                setRerenderAux(!rerenderAux);
            })
                .catch(e => {
                    alert('Não foi possível deletar o usuário: ' + userToDelete.nome + '\nMensagem: ' + e)
                })
        }
    }

    return (
        <Dialog.Root>
            <StyledTrigger>
                <FaUsersCogIcon />
            </StyledTrigger>

            <Dialog.Portal>
                <StyledOverlay />
                <StyledContent>
                    <StyledClose>
                        <AiFillCloseCircleIcon />
                    </StyledClose>

                    <Header>
                        <TitleHeader>
                            Gerenciar: {client.nome}
                        </TitleHeader>
                    </Header>
                    <Content>
                        <LeftSide>
                            <TitleContent>
                                Usuários Cadastrados
                            </TitleContent>
                            <ResponseList>
                                {
                                    responseBitrixUsers.map(item => {
                                        return (
                                            <li
                                                key={item.codUser}
                                                className='li-left'
                                            >
                                                <div className="left-li-text-box">
                                                    <h3>{item.codBitrix}</h3>
                                                </div>
                                                <div className="left-li-text-box">
                                                    <h2>{item.nome}</h2>
                                                </div>
                                                <div className="left-li-button-container">

                                                    <AiFillDeleteIcon
                                                        onClick={() => handleDeleteButon(item)}
                                                        title="Deletar usuário"
                                                    />
                                                    {/* <button className='left-li-button'>

                                                    </button> */}
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ResponseList>

                        </LeftSide>
                        <RightSide>
                            <TitleContent>
                                Novos Usuários
                            </TitleContent>
                            <SectionBox>
                                <label htmlFor="search">
                                    Nome do Usuário:
                                </label>
                                <input
                                    type="text"
                                    id="search"
                                    autoComplete="off"
                                    onChange={(e) => setTextSearch(e.target.value)}
                                    required
                                />
                            </SectionBox>
                            <ResponseList>
                                {
                                    responseSearchBitrix.map(item => {
                                        return (
                                            <li
                                                key={item.codUser}
                                                className='li-right'
                                            >
                                                <div className="right-li-text-box">
                                                    <h3>{item.codUser}</h3>
                                                </div>
                                                <div className="right-li-text-box">
                                                    <h2>{item.nomeUser} {item.lastName}</h2>
                                                </div>
                                                <div className="right-li-button-container">
                                                    <AddIcon onClick={() => handleAddButon(item)} title="Adicionar usuário padrão" />
                                                </div>
                                                <div className="right-li-button-container">
                                                    <AdminIcon onClick={() => handleAddAdminButon(item)} title="Adicionar ADMIN" />
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ResponseList>
                        </RightSide>
                    </Content>
                </StyledContent>
            </Dialog.Portal>

        </Dialog.Root>
    )

}

export default ManageClient;